angular.module('impactx.address')
    .directive('ixNumeric', function() {
        return {
            scope: {
                ctrl: "="
            },
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem, attrs, ngModelController) {

                if(ngModelController.$parsers) {
                    ngModelController.$parsers.push(createNumericStringValidator(ngModelController));
                }
            }
        };
    })
    .directive('ixPhoneNumber', function() {
        return {
            scope: {
                /**
                 * Data object with entries: countryCode, areaCode, networkCode, numberCode
                 */
                data: '=',
                /**
                 * Flag whether the data should be displayed without label
                 */
                onlyData: "=?",
                /**
                 * Translations
                 */
                trns: "=",
                /**
                 * Form which will contain the validation errors.
                 */
                form: "=",
                /**
                 * Read-only flag
                 */
                readonly: "@",
                /**
                 * Additional property controls the visibility of the label
                 */
                showLabel: "=?showLabel",
                /**
                 * Name used in the containing form.
                 */
                name: "=",
                /**
                 * Used to set the required flag.
                 */
                required: "=",
                /**
                 * Custom ID to use as base for internal field IDs and names.
                 */
                customId: "=?",
                /**
                 * Name prefix to use to create unique names.
                 */
                namePrefix: "@",
                /**
                 * Name of the outer field or form (can be used for errors)
                 */
                outerFieldName: "@",
                /**
                 * Flag if the formatted value should be generated dynamically.
                 */
                dynamic: "=?"
            },
            controller: "PhoneNumberController",
            controllerAs: 'ctrl',
            restrict: 'E',
            transclude: true,
            templateUrl: 'modules/address/templates/ix.phonenumber.tmpl.html',
            link: {
                post: function(scope, elem, attr, ctrl) {
                    var fieldMainName = "", nameFound = false;

                    ctrl.isRequired = false;

                    //Create unique field names and IDs
                    if(attr.name && attr.name.length > 0) {
                        fieldMainName = attr.name;
                        nameFound = (fieldMainName && fieldMainName.length > 0);
                    }

                    if(!nameFound && attr.customId && attr.customId.length > 0) {
                        fieldMainName = attr.customId;
                    }

                    if(attr.namePrefix && attr.namePrefix.length > 0) {
                        fieldMainName = attr.namePrefix + fieldMainName;
                    }

                    if(attr.required && attr.required == "true") {
                        // console.log('Is required');
                        ctrl.isRequired = true;
                    }

                    if(fieldMainName && fieldMainName.length > 0) {
                        ctrl.name = fieldMainName;
                        ctrl.countryId = fieldMainName + '-country';
                        ctrl.areaId = fieldMainName + '-area';
                        ctrl.networkId = fieldMainName + '-network';
                        ctrl.numberId = fieldMainName + '-number';
                        ctrl.labelId = fieldMainName + '-label';
                    }

                    ctrl.canEdit = true;

                    if(attr.hasOwnProperty('readonly')) {
                        ctrl.canEdit = !attr.readonly || attr.readonly == 'false';
                    }

                    if(scope.data) {

                        if(scope.data.hasOwnProperty('readOnly')) {
                            ctrl.canEdit = !scope.data.readOnly;
                        }
                    }

                    //Check and create fall-back error messages.
                    if(scope.trns) {
                        if(!scope.trns.invalidCountryCode) {
                            scope.trns.invalidCountryCode = 'Country code ?';
                        }

                        if(!scope.trns.invalidAreaCode) {
                            scope.trns.invalidAreaCode = 'Area code ?';
                        }

                        if(!scope.trns.invalidNetworkCode) {
                            scope.trns.invalidNetworkCode = 'Network code ?';
                        }

                        if(!scope.trns.invalidNumberCode) {
                            scope.trns.invalidNumberCode = 'Number code ?';
                        }
                    }
                }
            }
        }
    });